import { PRODUCT_IDS, STATUSES } from 'constants/AppConstants';

export const SUB_STATUSES = {
  Customer: 1,
  CRS: 2,
  BulkOrder: 3,
  Xactware: 4,
  UnderReview: 5,
  ProcessStarted: 6,
  SiteMap: 7,
  NeedToID: 8,
  Duplicate: 9,
  CanceledByClient: 10,
  PoorImages: 11,
  NoID: 12,
  TrainingFile: 13,
  ReportTypeChange: 14,
  NoImages: 15,
  Other: 16,
  System: 17,
  CardRejected: 18,
  Sent: 19,
  SentPM: 20,
  CustomerResponse: 21,
  iPhone: 22,
  Lautriv: 23,
  WrongHouse: 24,
  Clone: 25,
  ReadyToSend: 26,
  CreditCardFailure: 27,
  UnSketchable: 28,
  AddressVerified: 29,
  NotSent: 30,
  Processing: 31,
  MeasurementData: 32,
  PmReliant: 33,
  RTCVerified: 34,
  ReadyForSaranac: 35,
  NeedToIDFromSaranac: 36,
  WorkFinished: 37,
  UnsupportedStructure: 38,
  BlueprintVerified: 39,
  Submitted: 40,
  ImageResolutionRestriction: 41,
  ImageAgeRestriction: 42,
  ReadyToCapturePayment: 43,
  UnableToCollect: 44,
  ReadyForOnSiteImageCapture: 45,
  DroneRestrictions: 46,
  PropertyInspection: 47,
  PropertyInspectionDeliverableGeneration: 48,
  PendingClosure: 49,
  ClosureDenied: 50,
  ReadyForOnSiteImageRecapture: 51,
  NoSuitableVendor: 52,
  WaitingVendorApproval: 53,
  Cancellation: 54,
  Cancelled: 55,
  CancelledNoSuitableVendor: 56,
  ReadyForAppointmentScheduling: 57,
  AppointmentScheduling: 58,
  ReadyForMeasurementDataSync: 59,
  MeasurementDataSyncCompleted: 60,
  MeasurementDataSyncFailed: 61,
  CustomerApproval: 62,
  TriageInitiated: 63,
  TriageCompleted: 64,
  PendingScheduling: 65,
  ImageProcessingInitiated: 66,
  ImageProcessingCompleted: 67,
  AssessReviewCompleted: 68,
  CallbackScheduled: 69,
  ClearForecast: 70,
  SchedulingAssistance: 71,
  QCReviewPending: 72,
  QCReviewCompleted: 73,
  QCReviewRejected: 74,
  ImageIngestionInitiated: 75,
  ImageIngestionCompleted: 76,
  ManualAdjustmentPending: 77,
  ManualAdjustmentCompleted: 78,
  AppointmentCompleted: 79,
  AssessEscalation: 80,
  PendingRoofMeasurement: 81,
  ManualAdjustmentRejected: 82,
  MeasurementPending: 83,
  MeasurementCompleted: 84,
  QCPending: 85,
  QCCompleted: 86,
  MeasurementRejected: 87,
  QCRejected: 88,
  PendingMLAutomation: 89,
  MLAutomationCompleted: 90,
  MLAutomationRejected: 91,
  HipsterMeasurementPending: 92,
  HipsterMeasurementCompleted: 93,
  HipsterMeasurementRejected: 94,
  HipsterQCPending: 95,
  HipsterQCCompleted: 96,
  HipsterQCRejected: 97,
  MLAutomationStarted: 98,
  MLSFNAutomationCompleted: 99,
  UnderReviewTech: 100,
  AutoImageSelectionStarted: 101,
  AutoImageSelectionCompleted: 102,
  AutoImageSelectionFailed: 103,
  MLOrderQualificationStarted: 104,
  MLOrderQualificationFailed: 105,
  MLOrderQualificationCompleted: 106,
  AppointmentCanceled: 107,
  DiagenStarted: 108,
  DiagenFailed: 109,
  DiagenRejected: 110,
  DiagenCompleted: 111,
  WrongHouseRejection: 112,
  Abandoned: 113,
};

export const PAGE_SIZE_OPTIONS = [
  { id: 10, description: 10 },
  { id: 25, description: 25 },
  { id: 50, description: 50 },
  { id: 100, description: 100 },
];

export const PAGINATION_BREAKPOINT = 11;

export const FILE_FORMAT_NAMES = {
  1: 'JPG',
  2: 'PDF',
  3: 'DOC',
  4: 'XML',
  5: 'DXF',
  6: 'RXF',
  7: 'XLS',
  8: 'HTML',
  9: 'EMF',
  10: 'PNG',
  11: 'GIF',
  12: 'EPS',
  13: 'DOCX',
  14: 'DOT',
  15: 'DOTX',
  16: 'XLSX',
  17: 'EVM',
  18: 'JSON',
  19: 'ZIPJPGS',
  20: 'KML',
  21: 'EVA',
  22: 'OBJ',
  23: 'SKP',
  24: 'ZIP',
  25: 'CSV',
  26: 'ESX',
};

export const OTHER_STATUS_REASON_ID = 36;

export const EDIT_PITCH_PRODUCT_IDS = [
  PRODUCT_IDS.StandardResidential,
  PRODUCT_IDS.AA2D,
  PRODUCT_IDS.EC2DCommercial,
  PRODUCT_IDS.EC2DResidential,
  PRODUCT_IDS.PictometryStandard,
  PRODUCT_IDS.SketchOnly,
  PRODUCT_IDS.Roof2D,
];

export const MIN_SELECTED_OPTIONS_LENGTH = 0;
export const MAX_SELECTED_OPTIONS_LENGTH = 3;

export const STATUS_FILTER_VALUES = {
  Created: [[STATUSES.Created, null]],
  InProcess: [[STATUSES.InProcess, null]],
  ActionNeeded: [
    [STATUSES.Pending, SUB_STATUSES.CustomerResponse],
    [STATUSES.Pending, SUB_STATUSES.NeedToID],
    [STATUSES.Pending, SUB_STATUSES.SiteMap],
  ],
  CheckEmail: [[STATUSES.Pending, SUB_STATUSES.ReportTypeChange]],
  Closed: [[STATUSES.Closed, null]],
  Completed: [[STATUSES.Completed, null]],
};

export const CLAIM_INFO_FIELDS = {
  claimNumber: 'Claim ID',
  claimInfo: 'Claim Info',
  insuredName: 'Insured Name',
  catId: 'Cat ID',
  batchId: 'Batch ID',
  poNumber: 'PO Number',
  dependentReportExternalReferenceId: 'Reference ID',
  policyNumber: 'Policy Number',
  dateOfLoss: 'Date of Loss',
};

export const SUBSCRIPTION_STATUS_COLORS = {
  Included: {
    text: '#1F6800',
    background: '#E2F7DA',
    amount: '#144200',
  },
  Overage: {
    text: '#CC7000',
    background: '#FFF3CD',
    amount: '#B56114',
  },
  'N/A': {
    text: '#4D5365',
    background: '#F0F2F7',
    amount: '#4D5365',
  },
};
